import { Input, StarsButton, Translation } from '@ps/web-shared-components';
import { allowedLength, numbersOnly, required } from '@ps/web-shared-validators';
import classNames from 'clsx';
import React from 'react';
import { FormattedTime } from 'react-intl';

import ButtonGroup from '@swf/components/ButtonGroup/ButtonGroup';
import BackButton from '@swf/components/StarsModal/components/BackButton';
import useTimer from '@swf/core/hooks/useTimer';

import {
  TXTCLI_A_4_digit_verification_code_ha_ELL,
  TXTCLI_Please_enter_a_valid_codeX,
  TXTCLI_Send_new_code_inX_N0,
  TXTCLI_Submit,
  TXTWCL_Enter_code,
  TXTWCL_Resend_verification_code
} from './ValidateMobileCode.messages.json';
import styles from './ValidateMobileCode.scss';

interface Props {
  first?: boolean;
  goBack?(): void;
}

const INITIAL_SECONDS = 60;
const secondsDecrement = (seconds: number) => seconds - 1;

const ValidateMobileCode: React.FC<Props> = ({ first, goBack }) => {
  const secondsToResend = useTimer({ modifier: secondsDecrement, initial: INITIAL_SECONDS });

  return (
    <>
      {!first && <BackButton onClick={goBack} />}
      <p className={styles.paragraph}>
        <Translation {...TXTCLI_A_4_digit_verification_code_ha_ELL} />
      </p>
      <Input
        maxLength={4}
        id="validationCode"
        label={TXTWCL_Enter_code}
        validators={[
          required(),
          numbersOnly(TXTCLI_Please_enter_a_valid_codeX),
          allowedLength([4], TXTCLI_Please_enter_a_valid_codeX)
        ]}
      />
      <ButtonGroup className={classNames({ [styles.firstGroup]: first })}>
        <StarsButton
          className={classNames({ [styles.submit]: first })}
          type={first ? 'submit' : 'button'}
          translation={TXTCLI_Submit}
        />
        <StarsButton
          block
          disabled={secondsToResend > 0}
          variant="secondary"
          translation={
            secondsToResend > 0 ? TXTCLI_Send_new_code_inX_N0 : TXTWCL_Resend_verification_code
          }
          values={{
            0: (
              <FormattedTime
                value={new Date(secondsToResend * 1000)}
                minute="numeric"
                second="numeric"
              />
            )
          }}
        />
      </ButtonGroup>
    </>
  );
};

export default ValidateMobileCode;
